<template>
  <div>
    <Head title="Użytkownicy" />
    <h1 class="mb-8 text-3xl font-bold">
      Użytkownicy
    </h1>
    <div class="mb-6 flex items-center justify-between">
      <search-filter
        v-model="form.search"
        class="mr-4 w-full max-w-md"
        @reset="reset"
      >
        <label class="block text-gray-800" for="role-filter">Rola:</label>
        <select
          id="role-filter"
          v-model="form.role"
          class="form-select mt-1 w-full"
        >
          <option :value="null" />
          <option value="editor">
            Redaktor
          </option>
          <option value="admin">
            Administrator
          </option>
        </select>
      </search-filter>
      <!-- Temporarily disabled: restore Link when re-enabling create -->
      <button
        v-if="can.create_user"
        type="button"
        class="btn-indigo pointer-events-none cursor-not-allowed opacity-40"
        disabled
      >
        Dodaj użytkownika
      </button>
    </div>
    <div class="overflow-x-auto rounded-sm bg-white shadow-sm">
      <table class="w-full whitespace-nowrap">
        <thead>
          <tr class="text-left font-bold">
            <th class="px-6 pb-4 pt-6">
              Imię i nazwisko
            </th>
            <th class="px-6 pb-4 pt-6">
              E-mail
            </th>
            <th class="px-6 pb-4 pt-6">
              Rola
            </th>
            <th class="px-6 pb-4 pt-6" />
            <th class="w-px px-6 pb-4 pt-6">
              Akcje
            </th>
          </tr>
        </thead>
        <tbody>
          <tr
            v-for="user in users"
            :key="user.id"
            class="hover:bg-gray-50"
          >
            <td class="border-t">
              <div class="flex items-center px-6 py-4">
                <img
                  v-if="user.photo"
                  class="-my-2 mr-2 block h-5 w-5 rounded-full"
                  :src="user.photo"
                  alt="Zdjęcie"
                >
                {{ user.name }}
              </div>
            </td>
            <td class="border-t">
              <div class="flex items-center px-6 py-4">
                {{ user.email }}
              </div>
            </td>
            <td class="border-t">
              <div class="flex items-center px-6 py-4">
                {{ roleLabel(user.role) }}
              </div>
            </td>
            <td class="border-t" />
            <td class="w-px border-t">
              <div class="ml-4 flex shrink-0 items-center gap-2 px-4">
                <!-- Temporarily disabled: restore Link + click handlers when re-enabling -->
                <button
                  v-if="user.id"
                  type="button"
                  class="btn-action-edit pointer-events-none cursor-not-allowed opacity-40"
                  title="Edytuj"
                  disabled
                >
                  <icon name="edit" class="mr-1.5 h-3.5 w-3.5 stroke-current" />
                  Edytuj
                </button>
                <button
                  v-if="user.id && can.create_user"
                  type="button"
                  class="btn-action-delete pointer-events-none cursor-not-allowed opacity-40"
                  title="Usuń"
                  disabled
                >
                  <icon name="trash" class="mr-1.5 h-3.5 w-3.5 stroke-current" />
                  Usuń
                </button>
              </div>
            </td>
          </tr>
          <tr v-if="users.length === 0">
            <td class="border-t px-6 py-4" colspan="5">
              Nie znaleziono użytkowników.
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</template>

<script>
import { Head } from '@inertiajs/vue3';
import Icon from '@/Shared/Icon.vue';
import Layout from '@/Layouts/Admin.vue';
import mapValues from 'lodash/mapValues';
import pickBy from 'lodash/pickBy';
import SearchFilter from '@/Shared/SearchFilter.vue';
import throttle from 'lodash/throttle';

const ROLE_LABELS = {
  admin: 'Administrator',
  editor: 'Redaktor',
};

export default {
  components: {
    Head,
    Icon,
    SearchFilter,
  },
  layout: Layout,
  props: {
    users: {
      type: Array,
      required: true,
    },
    filters: {
      type: Object,
      required: true,
    },
    can: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      form: {
        search: this.filters.search,
        role: this.filters.role,
      },
    };
  },
  watch: {
    form: {
      handler: throttle(function () {
        let query = pickBy(this.form);
        this.$inertia.get(
          this.$routes.users(
            Object.keys(query).length ? query : { remember: 'forget' },
          ),
          {},
          {
            preserveState: true,
            preserveScroll: true,
            replace: true,
            only: ['users'],
          },
        );
      }, 150),
      deep: true,
    },
  },
  methods: {
    roleLabel(role) {
      return ROLE_LABELS[role] || role;
    },
    reset() {
      this.form = mapValues(this.form, () => null);
    },
    destroy(user) {
      if (confirm('Czy na pewno chcesz usunąć tego użytkownika?')) {
        this.$inertia.delete(this.$routes.user(user.id));
      }
    },
  },
};
</script>
